export enum FieldClassifications {
    NewField = "NewField",
    Green = "Green",
    Orange = "Orange",
    Red = "Red",
}
